import { KeyValue } from '@angular/common';

export function trackByRoute(index: number, item: any): string | number {
  // If route exists and is not empty, use it
  if (item?.route && item.route.trim() !== '') {
    return item.route;
  }
  
  // For items without route (or empty route), use label + type
  if (item?.label) {
    return `${item.type || 'item'}-${item.label}`;
  }
  
  // Fallback to index
  return `item-${index}`;
}

export function trackById<T extends { id: string | number }>(index: number, item: T) {
  return item.id;
}

export function trackByKey(index: number, item: KeyValue<any, any>) {
  return item.key;
}

export function trackByValue(index: number, value: string) {
  return value;
}

export function trackByLabel<T extends { label: string }>(index: number, value: T) {
  return value.label;
}
